import { useMemo } from 'react';

import { useRelationshipsContext } from '../providers/RelationshipsProvider';

/**
 * This hook allows getting relationship service data.
 * It must be used inside `RelationshipsProvider` component.
 *
 * The returned array contains objects of shape:
 *   {
 *     id: '123',
 *     entities: [{
 *       id: '456',
 *       domain: 'autodesk-bim360-documentmanagement',
 *       type: 'documentversion'
 *     }, {
 *       id: '789',
 *       domain: 'autodesk-construction-sheet',
 *       type: 'sheetversion'
 *     }]
 *   }
 *
 * @param id - the ID to get relationship data for
 * @param domain - the domain to get relationship data for
 * @param type - the type to get relationship data for
 * @return {{data: array<object>}}
 */
export default ({ id, domain, type }) => {
  const { relationshipDataBySource, relationshipsEntityMap } =
    useRelationshipsContext();

  return useMemo(() => {
    const sourceData = relationshipDataBySource?.[domain]?.[type]?.[id];

    return {
      data: sourceData?.relationshipsData.map(
        ({ relationshipId }) => relationshipsEntityMap[relationshipId],
      ),
    };
  }, [domain, type, id, relationshipDataBySource, relationshipsEntityMap]);
};
